import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { auth } from '../firebase';
import CustomHeader from './CustomHeader';

const PrivateRoute = ({ element: Component, ...rest }) => {
  const isAuthenticated = auth.currentUser !== null;

  return isAuthenticated ? (
    <>
      <CustomHeader />
      <Outlet />
    </>
  ) : (
    <Navigate to="/" />
  );
};

export default PrivateRoute;
